module.exports = __webpack_public_path__ + "static/media/WeddingFashion.5519ca32.png";